(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pc-hero-slides')) {
    /* Cross-fades .pc-hero__slide children; the first slide is active in the markup, so without
       JavaScript the hero simply shows it. Autoplay stops for reduced motion, while the pointer
       or focus is inside (banner carousel), when scrolled away, and with the pause button. */
    class PcHeroSlides extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.pc-hero__slide'));
        if (this.slides.length < 2) return;
        if (!this.ready) this.setUp();

        this.observer = new IntersectionObserver(([entry]) => this.hold('offscreen', !entry.isIntersecting));
        this.observer.observe(this);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
        this.schedule();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.observer?.disconnect();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      /* once per element: state and the listeners on the element itself */
      setUp() {
        this.ready = true;
        this.index = 0;
        this.delay = (Number(this.dataset.interval) || 6) * 1000;
        this.dots = Array.from(this.querySelectorAll('[data-pc-go]'));
        this.toggle = this.querySelector('[data-pc-toggle]');
        this.holds = new Set();
        this.setStopped(this.dataset.autoplay === 'false' || matchMedia('(prefers-reduced-motion: reduce)').matches);

        this.onBlockSelect = (event) => {
          const i = this.slides.indexOf(event.target);
          if (i < 0) return;
          this.go(i);
          this.hold('editor', true);
        };
        this.onBlockDeselect = () => this.hold('editor', false);

        this.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-pc-next')) this.go(this.index + 1);
          if (button.hasAttribute('data-pc-prev')) this.go(this.index - 1);
          if (button.hasAttribute('data-pc-go')) this.go(Number(button.dataset.pcGo));
          if (button.hasAttribute('data-pc-toggle')) this.setStopped(!this.stopped);
        });

        if (this.dots.length) {
          this.addEventListener('pointerenter', () => this.hold('pointer', true));
          this.addEventListener('pointerleave', () => this.hold('pointer', false));
          this.addEventListener('focusin', () => this.hold('focus', true));
          this.addEventListener('focusout', (event) => {
            if (!this.contains(event.relatedTarget)) this.hold('focus', false);
          });
          this.addEventListener('pointerdown', (event) => (this.startX = event.clientX));
          this.addEventListener('pointerup', (event) => {
            const dx = event.clientX - (this.startX ?? event.clientX);
            if (Math.abs(dx) > 48) this.go(this.index + (dx < 0 ? 1 : -1));
          });
        }
      }

      go(next) {
        const count = this.slides.length;
        const target = ((next % count) + count) % count;
        if (target !== this.index) {
          const leaving = this.slides[this.index];
          leaving.classList.remove('is-active');
          leaving.setAttribute('inert', '');
          const entering = this.slides[target];
          entering.classList.add('is-active');
          entering.removeAttribute('inert');
          this.index = target;
          this.dots.forEach((dot, i) => dot.toggleAttribute('aria-current', i === target));
        }
        this.schedule();
      }

      hold(reason, on) {
        if (on) this.holds.add(reason);
        else this.holds.delete(reason);
        this.schedule();
      }

      setStopped(stopped) {
        this.stopped = stopped;
        this.classList.toggle('is-paused', stopped);
        this.toggle?.setAttribute('aria-label', stopped ? this.dataset.labelPlay : this.dataset.labelPause);
        this.schedule();
      }

      schedule() {
        clearTimeout(this.timer);
        if (this.stopped || this.holds.size) return;
        this.timer = setTimeout(() => this.go(this.index + 1), this.delay);
      }
    }
    customElements.define('pc-hero-slides', PcHeroSlides);
  }

  } catch(e) { console.error(e); }
})();
})();
